import * as Preact from "preact"
import PolygonClipping from "polygon-clipping"

import App from "@fae/source/models/App.js"

import Dev from "@fae/source/models/dev/Dev.js"
import SequenceAnimation from "@fae/source/engine/animating/SequenceAnimation.js"

import Geometry from "@fae/source/utility/Geometry.js"
import Loop from "@fae/source/engine/Loop.js"
import Random from "@fae/source/utility/Random.js"
const random = new Random()
Math.clamp = function(min = 0, max = 1, value) {
    return Math.max(min, Math.min(max, value))
}

import Camera from "@fae/source/views/components/Camera.jsx"
import Cursor from "@fae/source/views/components/Cursor.jsx"
import Unit from "@fae/source/views/components/Unit.jsx"
import "@fae/source/views/Stage.less"

import skills from "@fae/source/data/skills.jsx"

import EncounterArea from "@fae/source/views/components/EncounterArea.jsx"

export default class Stage {
    render() {
        return (
            <div class="Stage" phase={this.props.stage.player.phase} isBlurred={this.isBlurred}>
                <WorldImage stage={this.props.stage} screenspace="camera"/>
                <Camera chapter={App.game.chapter}>
                    <Squiggles/>
                    <WorldImage stage={this.props.stage} screenspace="world"/>
                    <Blocks stage={this.props.stage}/>
                    <Edges stage={this.props.stage}/>

                    <Units stage={this.props.stage}/>
                    <Particles stage={this.props.stage}/>

                    <Cursor stage={this.props.stage}/>
                    <ActionRange stage={this.props.stage}/>
                    <ActionArrow stage={this.props.stage}/>
                    <BloodlustRange stage={this.props.stage}/>

                    {Object.values(this.props.stage.encounters).map((encounter) => {
                        if(App.game?.configuration?.isRenderingEncounters
                        || this.props.stage.configuration?.isRenderingEncounters) {
                            return (
                                <EncounterArea encounter={encounter}/>
                            )
                        }
                    })}
                    {Object.values(this.props.stage.world.spots).map((spot) => {
                        if(App.game?.configuration?.isRenderingSpots
                        && (spot.hasCollision == true || spot.isVisible == true)) {
                            return (
                                <div class="Spot" style={{
                                    "top": spot.position.y + "em",
                                    "left": spot.position.x + "em",
                                    "backgroundColor": "black",
                                    "z-index": 100,
                                }}/>
                            )
                        }
                    })}
                </Camera>
                <Squiggles/>
            </div>
        )
        // <Darkness stage={this.props.stage}/>
        // <Water stage={this.props.stage}/>
        // <Spots stage={this.props.stage}/>
        // {Object.values(this.props.stage.encounters).map((encounter) => {
        //     if(App.game?.key == "ember") {
        //         return (
        //             <EncounterArea encounter={encounter}/>
        //         )
        //     }
        // })}
        // {Object.values(this.props.stage.world.spots).map((spot) => {
        //     if(App.game?.key == "ember"
        //     && spot.hasCollision == true) {
        //         return (
        //             <div class="Spot" style={{
        //                 "top": spot.position.y + "em",
        //                 "left": spot.position.x + "em",
        //                 "backgroundColor": "black",
        //                 "z-index": 100,
        //             }}/>
        //         )
        //     }
        // })}
    }
    get isBlurred() {
        return this.props.stage.dialogue != undefined
            && this.props.stage.dialogue.type == "Gameplay"
            // TODO: Define better flags for blurring the scene
    }
}

class Particles {
    render() {
        if(App.options.disableParticles == true) return
        if(this.props.stage.particles == undefined) return
        return Object.values(this.props.stage.particles).map((particle) => {
            if(particle.text != undefined) {
                return (
                    <div class="Particle" type={particle.stack || "damage"} style={{
                        "left": particle.position.x + "em",
                        "top": particle.position.y + "em",
                        // "color": particle.color,
                        "opacity": particle.opacity,
                    }}>
                        <div class="Texting">{particle.text?.string}</div>
                    </div>
                )
            } else if(particle.image != undefined) {
                return (
                    <div class="Particle" type="image" style={{
                        "left": particle.position.x + "em",
                        "top": particle.position.y + "em",
                        "background-image": "url(" + particle.image + ")",
                        "opacity": particle.opacity,
                    }}/>
                )
            }
        })
    }
}

function Edges() {
    if(this.props.stage.world.edges == undefined) return
    return Object.values(this.props.stage.world.edges).map((edge) => {
        if(edge.tilegid == 8) {
            return (
                <div class="Wall" style={{
                    "top": edge.position.y + "em",
                    "left": edge.position.x + "em",
                    "z-index": 100 + (edge.position.y * 10) + 1,
                }}/>
            )
        }
    })
}

function Blocks() {
    if(this.props.stage.world.blocks == undefined) return
    return (
        <div class="Blocks">
            {Object.values(this.props.stage.world.blocks).map((block) => {
                if(block.image != undefined) {
                    return (
                        <div class="Block" style={{
                            "top": block.position.y + "em",
                            "left": block.position.x + "em",
                            "backgroundImage": "url(" + block.image + ")",
                            "width": (block?.size?.x ?? 1) + "em",
                            "height": (block?.size?.y ?? 1) + "em",
                            "margin-top": -1 * ((block?.size?.y ?? 1) - 1) + "em",
                            "margin-left": -1 * ((block?.size?.x ?? 1) - 1) + "em",
                        }}/>
                    )
                }
            })}
        </div>
    )
}

function Squiggles() {
    const baseFrequency = "0.08"
    return (
        <svg display="none">
            <defs>
                <filter id="squiggly-0">
                    <feTurbulence id="turbulence" baseFrequency={baseFrequency} numOctaves="3" result="noise" seed="0"/>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="2" />
                </filter>
                <filter id="squiggly-1">
                    <feTurbulence id="turbulence" baseFrequency={baseFrequency} numOctaves="3" result="noise" seed="1"/>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="3" />
                </filter>
                <filter id="squiggly-2">
                    <feTurbulence id="turbulence" baseFrequency={baseFrequency} numOctaves="3" result="noise" seed="2"/>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="2" />
                </filter>
                <filter id="squiggly-3">
                    <feTurbulence id="turbulence" baseFrequency={baseFrequency} numOctaves="3" result="noise" seed="3"/>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="3" />
                </filter>
                <filter id="squiggly-4">
                    <feTurbulence id="turbulence" baseFrequency={baseFrequency} numOctaves="3" result="noise" seed="4"/>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="2" />
                </filter>
                <filter id="squiggly-5">
                    <feTurbulence id="turbulence" baseFrequency={baseFrequency} numOctaves="3" result="noise" seed="5"/>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="2" />
                </filter>
                <filter id="squiggly-6">
                    <feTurbulence id="turbulence" baseFrequency={baseFrequency} numOctaves="3" result="noise" seed="6"/>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="2" />
                </filter>
                <filter id="squiggly-7">
                    <feTurbulence id="turbulence" baseFrequency={baseFrequency} numOctaves="3" result="noise" seed="7"/>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="2" />
                </filter>
                <filter id="squiggly-8">
                    <feTurbulence id="turbulence" baseFrequency={baseFrequency} numOctaves="3" result="noise" seed="8"/>
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="2" />
                </filter>
            </defs>
        </svg>
    )
}

function emify(point) {
    return point.x + "em" + " " + point.y + "em"
}
let flickering = 0.5
function Darkness({stage}) {
    if(stage.world == undefined) return
    if(stage.currentEncounterKey == undefined) return

    let points = [
        "0em 0em",
        "0em " + stage.world.height + "em",
        stage.world.width + "em" + " " + stage.world.height + "em",
        stage.world.width + "em" + " " + "0em",
    ]

    const darkness = stage.configuration?.darkness || App.game.configuration.darkness

    if(darkness == "none") {
        return
    }

    let polygons = []
    if(darkness == false) {
        const encounter = stage.world.encounters[stage.currentEncounterKey + "s"] || stage.world.encounters[stage.currentEncounterKey]
        if(encounter.points != undefined) {
            polygons.push([
                ...encounter.points,
                encounter.points[0]
            ])
        } else {
            const x1 = encounter.x
            const y1 = encounter.y
            const x2 = encounter.x + encounter.width
            const y2 = encounter.y + encounter.height
            polygons.push([
                {"x": x1, "y": y1},
                {"x": x2, "y": y1},
                {"x": x2, "y": y2},
                {"x": x1, "y": y2},
                {"x": x1, "y": y1},
            ])
        }
    }

    if(darkness == true
    || darkness == "night"
    || darkness == "shadow") {
        flickering = Math.clamp(-0.25, 0.25, flickering + random.range(-0.05, 0.05))
        const flux = darkness == "night" ? flickering : 0

        Object.values(stage.encounters).map((encounter) => {
            // if(parseInt(encounter.key) > parseInt(stage.currentEncounterKey)) return
            if(encounter.key != stage.currentEncounterKey
            && encounter.hasBeenSeen != true) {
                return
            }
            if(stage.encounters[encounter.key + "s"] != undefined) {
                encounter = stage.encounters[encounter.key + "s"]
            }
            if(encounter.points != undefined) {
                polygons.push([
                    ...encounter.points,
                    encounter.points[0]
                ].map((point, index) => {
                    const vector = Geometry.multiply(point.internalAngle, flux)
                    return Geometry.add(point, vector)
                }))
            } else {
                const x1 = encounter.x - flux
                const y1 = encounter.y - flux
                const x2 = encounter.x + encounter.width + flux
                const y2 = encounter.y + encounter.height + flux
                polygons.push([
                    {"x": x1, "y": y1},
                    {"x": x2, "y": y1},
                    {"x": x2, "y": y2},
                    {"x": x1, "y": y2},
                    {"x": x1, "y": y1},
                ])
            }
        })

        if(polygons.length == 0) return

        polygons = PolygonClipping.union(
            ...polygons.map((polygon) => {
                const array = polygon.map((point) => {
                    return [point.x, point.y]
                })
                return [array]
            })
        ).map((polygon) => {
            polygon = polygon[0]
            return polygon.map((point) => {
                return {"x": point[0], "y": point[1]}
            })
        })
    }

    polygons.forEach((polygon) => {
        polygon.unshift({"x": 0, "y": 0})
    })
    polygons = polygons.map((polygon) => {
        return polygon.map((point) => emify(point))
    })
    polygons.forEach((polygon) => {
        points = points.concat(polygon)
    })

    return (
        <div class="Darkness" type={darkness} style={{
            "width": stage.world.width + "em",
            "height": stage.world.height + "em",
            // "top": (stage.imageOffset?.y || 0) + "em",
            // "left": (stage.imageOffset?.x || 0) + "em",
            "clip-path": "polygon(" + points.join(", ") + ")",
        }}/>
    )
}

const ARROW_IMAGES = {
    "north-end": require("@fae/source/assets/images/hero-tactics-ii/arrow/north-end.png"),
    "north-start": require("@fae/source/assets/images/hero-tactics-ii/arrow/north-start.png"),
    "south-end": require("@fae/source/assets/images/hero-tactics-ii/arrow/south-end.png"),
    "south-start": require("@fae/source/assets/images/hero-tactics-ii/arrow/south-start.png"),
    "east-end": require("@fae/source/assets/images/hero-tactics-ii/arrow/east-end.png"),
    "east-start": require("@fae/source/assets/images/hero-tactics-ii/arrow/east-start.png"),
    "west-end": require("@fae/source/assets/images/hero-tactics-ii/arrow/west-end.png"),
    "west-start": require("@fae/source/assets/images/hero-tactics-ii/arrow/west-start.png"),
    "north-west": require("@fae/source/assets/images/hero-tactics-ii/arrow/north-west.png"),
    "north-east": require("@fae/source/assets/images/hero-tactics-ii/arrow/north-east.png"),
    "south-west": require("@fae/source/assets/images/hero-tactics-ii/arrow/south-west.png"),
    "south-east": require("@fae/source/assets/images/hero-tactics-ii/arrow/south-east.png"),
    "east-west": require("@fae/source/assets/images/hero-tactics-ii/arrow/east-west.png"),
    "north-south": require("@fae/source/assets/images/hero-tactics-ii/arrow/north-south.png"),
}

class ActionArrow {
    render() {
        if(Dev.inProtoMode) return
        if(App.options.disableActionUI == true) return
        if(App.sequence != undefined
        && App.sequence?.steps?.length > 0) {
            return
        }

        return [this.move, this.attack]
    }
    get attack() {
        const action = App.game.chapter.selection.hoveredAction
        if(action == undefined) return

        if(action.type == "act") {
            const previousPosition = action.positions[1]
            const direction = Geometry.direction(action.positions[0], action.positions[1])
            const position = Geometry.add(action.positions[1], Geometry.multiply(direction, 0.5))
            const icon = skills[action.skillKey]?.icon

            return (
                <div class="AttackArrow" role={action.role} key={action.skillKey} style={{
                    "top": position.y + "em",
                    "left": position.x + "em",
                    "background-image": icon && "url(" + icon + ")",
                }}/>
            )
        }
    }
    get move() {
        const action = App.game.chapter.selection.hoveredAction
        if(action == undefined) return

        const positions = action.positions.filter((position) => {
            return position.type == "wait"
                || position.type == "move"
                || position.type == "move through"
        })

        positions.forEach((position, index) => {
            const previousPosition = positions[index - 1]
            const nextPosition = positions[index + 1]
            const currentPosition = positions[index]

            let previousDirection = Geometry.label(Geometry.subtract(previousPosition, currentPosition))
            let nextDirection = Geometry.label(Geometry.subtract(nextPosition, currentPosition))

            if(previousPosition == undefined) previousDirection = "end"
            if(nextPosition == undefined) nextDirection = "start"

            position.image = ARROW_IMAGES[previousDirection + "-" + nextDirection] || ARROW_IMAGES[nextDirection + "-" + previousDirection]
        })

        return (
            <div class="MoveArrow">
                {positions.map((position) => (
                    <div class="Move" style={{
                        "left": position.x + "em",
                        "top": position.y + "em",
                        "background-image": position.image && "url(" + position.image + ")"
                    }}/>
                ))}
            </div>
        )
    }
}
function getAngleBetweenPoints(p1, p2) {
    return Math.atan2(p2.y - p1.y, p2.x - p1.x) * 180 / Math.PI
}

class WorldImage {
    render() {
        if(this.props.stage.images == undefined
        && this.props.stage.image != undefined) {
            this.props.stage.images = [this.props.stage.image]
        }
        if(this.props.stage.images == undefined) return
        const currentEncounter = this.props.stage.encounters[this.props.stage.currentEncounterKey]
        return this.props.stage.images.map((image, index) => {
            if((image.screenspace ?? "world") != this.props.screenspace) return // TODO: add a sane default if no screenspace is provided
            if(image.type == "polygon") {
                return <WorldImagePolygon stage={this.props.stage} image={image}/>
            } else if(image.type == "lined-polygon") {
                return <WorldImageLinedPolygon stage={this.props.stage} image={image}/>
            }
            return (
                <div class="WorldImage" isGrid={image.isGrid} style={{
                    "background": image.background,
                    "background-color": image.color,
                    "background-image": "url(" + (image.url || image) + ")",
                    "width": (image.width ?? this.props.stage.world.width ?? 16) + "em",
                    "height": (image.height ?? this.props.stage.world.height ?? 9) + "em",
                    "top": (image.position?.y ?? image.y ?? 0) + "em",
                    "left": (image.position?.x ?? image.x ?? 0) + "em",
                    "z-index": image.position?.z ?? image.z ?? 0,
                    "mix-blend-mode": image.effect,
                    "transform": "rotate(" + (image.rotation ?? 0) + "deg)",
                    "margin-left": ((image.anchor?.x ?? 0) * image.width * -1) + "em",
                    "margin-top": ((image.anchor?.y ?? 0) * image.height * -1) + "em",
                    "box-shadow": image.boxshadow,
                    // "filter": image.isAnimated && `url("#squiggly-1")`
                    // "animationName": image.isAnimated && "rustling",
                    // "animationDelay": image.index * -1 + "s",
                    // "animationDuration": "10s",
                    "animationName": (App.game?.configuration?.squigglevision == "world" && index != 0 ? "squigglevision" : (image.isSquiggling ? "squigglevision" : "")),
                    "background-position-x": (image.anchor?.x || 0) * 100 + "%",
                    "background-position-y": (image.anchor?.y || 0) * 100 + "%",

                    "opacity": image.isFaded instanceof Function && image.isFaded(this.props.stage) == true ? 0.75 : (image.opacity ?? 1),
                    "display": image.isHidden instanceof Function && image.isHidden(this.props.stage) == true ? "none" : "block",
                }}/>
            )
        })
    }
    // get encounters() {
    //     if(this.props.stage.encounters == undefined) return
    //     return Object.values(this.props.stage.encounters).map((encounter) => {
    //         if(this.props.stage.currentEncounterKey < encounter.key) return
    //         if(encounter.color == undefined) return
    //         return (
    //             <div class="EncounterImage" style={{
    //                 "width": encounter.width + "em",
    //                 "height": encounter.height + "em",
    //                 "left": encounter.x + "em",
    //                 "top": encounter.y + "em",
    //                 "backgroundColor": encounter.color,
    //             }}/>
    //         )
    //     })
    // }
}

function WorldImagePolygon({stage, image}) {
    let points = [...image.points]

    let x1 = Infinity
    let x2 = -Infinity
    let y1 = Infinity
    let y2 = -Infinity
    points.forEach((point) => {
        if(point.x < x1) x1 = point.x
        if(point.x > x2) x2 = point.x
        if(point.y < y1) y1 = point.y
        if(point.y > y2) y2 = point.y
    })
    let width = x2 - x1
    let height = y2 - y1

    points = points.map((point) => {
        return {
            "x": point.x - x1,
            "y": point.y - y1,
        }
    })

    points = points.map((point) => emify(point))

    return (
        <div class="WorldImagePolygon" style={{
            "width": width + "em",
            "height": height + "em",
            // "top": (stage.imageOffset?.y || 0) + "em",
            // "left": (stage.imageOffset?.x || 0) + "em",
            "clip-path": "polygon(" + points.join(", ") + ")",
            "background-color": image.color,
            "z-index": image.position?.z ?? image.z,
            "top": y1 + "em",
            "left": x1 + "em",
        }}/>
    )
}
function WorldImageLinedPolygon({stage, image}) {
    const minX = Math.min(...image.points.map((point) => point.x)) - 1
    const maxX = Math.max(...image.points.map((point) => point.x)) + 1
    const minY = Math.min(...image.points.map((point) => point.y)) - 1
    const maxY = Math.max(...image.points.map((point) => point.y)) + 1

    const SCALE = 16
    const BUFFER = 0
    const width = maxX - minX
    const height = maxY - minY

    let polygon = []
    polygon = [
        ...image.points,
        image.points[0],
        image.points[1],
    ]
    polygon = polygon.map((point) => {
        return {
            "x": (point.x - minX) + BUFFER,
            "y": (point.y - minY) + BUFFER,
        }
    })
    const polygonStrings = polygon.map((point) => {
        return (point.x * SCALE) + "," + (point.y * SCALE)
    })

    return (
        <svg
            class="WorldImageLinedPolygon"
            viewBox={"0 0 " + (width * SCALE) + " " + (height * SCALE)}
            style={{
                "position": "absolute",
                "top": (minY - BUFFER) + "em",
                "left": (minX - BUFFER) + "em",
                "width": (width + BUFFER + BUFFER) + "em",
                "height": (height + BUFFER + BUFFER) + "em",
                "animationName": (App.game?.configuration?.squigglevision == "world" ? "squigglevision" : (image.isSquiggling ? "squigglevision" : "")),
            }}>
            <polyline points={polygonStrings.join(" ")}/>
        </svg>
    )
}

class Units {
    render() {
        const stage = this.props.stage
        return Object.values(stage.units).map((unit, index) => {
            if(unit == undefined) return
            if(unit.isDead == true) return
            if(unit.isRemoved == true) return
            if(unit.isNotRendered) return

            const roundedPosition = {
                "x": Math.round(unit.position.x),
                "y": Math.round(unit.position.y),
                "z": Math.round(unit.position.z)
            }

            if((stage.configuration?.darkness != "none"
            || App.game.configuration.encounterViewOnly == true)
            && stage.flags["ShowAllTheGuys"] != true) { // for pirates
                if(stage.currentEncounterKey != undefined
                && Geometry.isInBounds(stage.encounters[stage.currentEncounterKey], roundedPosition) == false) {
                    return
                }
            }

            let omegaunit = undefined
            if(SequenceAnimation.isPerforming != true
            && App.game.chapter?.selection?.hoveredAction?.omegastage?.units[unit.key] != undefined) {
                omegaunit = App.game.chapter.selection.hoveredAction.omegastage.units[unit.key]
            }

            return <Unit stage={stage} unit={unit} omegaunit={omegaunit} index={index}/>
        })
    }
}

class ActionRange {
    render() {
        if(App.options.disableActionUI == true) return
        // if(App.game.chapter.phase != "play") return
        if(App != undefined
        && App.sequence?.steps?.length > 0) {
            return
        }

        if(App.game.chapter.selection.selectedUnitKey != undefined) {
            return (
                <UnitActionRange stage={this.props.stage}
                    unit={this.props.stage.units[App.game.chapter.selection.selectedUnitKey]}/>
            )
        }

        if(App.game.chapter.selection.hoveredUnitKey != undefined) {
            return (
                <UnitActionRange stage={this.props.stage}
                    unit={this.props.stage.units[App.game.chapter.selection.hoveredUnitKey]}/>
            )
        }
    }
}
class BloodlustRange {
    render() {
        // if(App.game.chapter.phase != "play") return
        if(App.game.configuration.renderBloodlust != true) return

        const stage = this.props.stage || App.game.chapter.stage
        if(stage == undefined) return

        return Object.values(stage.units).map((unit) => {
            if(unit.spotTag == "warning") {
                return <UnitActionRange stage={stage} unit={unit} isBloodlust={true}/>
            }
        })
    }
}

class UnitActionRange {
    render() {
        const unit = this.props.unit
        const stage = this.props.stage

        if(unit == undefined) return
        if(unit.isDead == true) return

        let actionmap = unit.actionmap
        if(stage.nextTurn != undefined
        && stage.nextTurn.aiActions != undefined
        && stage.nextTurn.aiActions[unit.key] != undefined
        && stage.nextTurn.aiActions[unit.key].actionmap != undefined) {
            actionmap = stage.nextTurn.aiActions[unit.key].actionmap
        }
        if(actionmap == undefined) {
            actionmap = App.game.chapter.stage.units[unit.key]?.actionmap
        }
        if(actionmap == undefined) {
            return
        }

        return Object.values(actionmap).map((actionlist, positionKey) => {
            const action = App.game.chapter.selection.findActionInActionlist({unit, actionlist})
            if(action == undefined) return
            return <UnitActionRangeTile stage={this.props.stage} unit={this.props.unit} action={action} isBloodlust={this.props.isBloodlust}/>
        })
    }
}

import World from "@fae/source/models/World.js"
class UnitActionRangeTile {
    render() {
        const tileKey = this.props.unit.key + "/" + this.props.action.position.x + "x" + this.props.action.position.y + "/" + Math.ceil(this.props.stage.turn.number / 2)
        return (
            <div class="UnitActionRangeTile" style={this.style} isBloodlust={this.props.isBloodlust} key={tileKey}>
                <div class="Sprite" type={this.type} style={this.spritestyle} key={tileKey} isNonPlayer={this.isNonPlayer}/>
            </div>
        )
    }
    get style() {
        // const terrain = World.getTerrain(this.props.stage.world, this.props.action.position)
        // if(terrain == undefined) return
        return {
            "left": this.props.action.position.x + "em",
            "top": this.props.action.position.y + "em",
            "opacity": App.game.chapter.selection.selectedUnitKey == this.props.unit.key ? 0.75 : 0.5,
        }
    }
    // get spritestyle() {
    //     return {
    //         "animation-delay": (1 + Geometry.distance(this.props.unit.position, this.props.action.position) / 2) + "s",
    //     }
    // }
    get type() {
        if(this.props.stage.units[this.props.action.performerKey].affiliation != this.props.stage.player.affiliation) {
            return "enemy action"
        }
        if((this.props.action.type == "act" || this.props.action.type == "act - can not target")
        && (this.props.action.role == "support" || this.props.action.role == "reposition")) {
            return "support action"
        }
        return this.props.action.type
    }
    get isNonPlayer() {
        return this.props.stage.units[this.props.action.performerKey].affiliation != this.props.stage.player.affiliation
    }
}
